import type { PropsWithChildren } from 'react';

import * as styles from './index.css';
import { Outlet } from 'react-router-dom';

function SettingsContentLayout({ children }: PropsWithChildren) {
  return <div className={styles.content}>{children ?? <Outlet />}</div>;
}

export default SettingsContentLayout;
